export default __webpack_public_path__ + "static/piconext-icon-bc9265463d9a902916876a8b728c710e.png";